import CommonApi from "../common/CommonApi";
import axios from "axios";
import SuccessResponse from "../dto/common/SuccessResponse";
import CommonRequestBodyDto from "../dto/common/CommonRequestBodyDto";
import PgCodeDto from "../dto/pgcode/PgCodeDto";
import PgCodeSaveReqDto from "../dto/pgcode/PgCodeSaveReqDto";
import PgCodeUpdateReqDto from "../dto/pgcode/PgCodeUpdateReqDto";

class RealPgCodeApi extends CommonApi {
    async getPgCode({ storeId }: { storeId: string }): Promise<SuccessResponse<PgCodeDto>> {
        const baseHeaders = this.makeBaseHeader();

        await axios.options(`${this.BASE_SERVICE_URL}/pg/code`, {
            headers: baseHeaders,
        });

        const response = await axios.get<SuccessResponse<PgCodeDto>>(`${this.BASE_SERVICE_URL}/pg/code`, {
            headers: baseHeaders,
            params: { store: storeId },
        });

        return response.data;
    }

    async savePgCode(
        reqDto: CommonRequestBodyDto<PgCodeSaveReqDto>
    ): Promise<SuccessResponse<{ idPgCode: number }>> {
        const baseHeaders = this.makeBaseHeader();

        await axios.options(`${this.BASE_SERVICE_URL}/pg/code`, {
            headers: baseHeaders,
        });

        const response = await axios.post<SuccessResponse<{ idPgCode: number }>>(
            `${this.BASE_SERVICE_URL}/pg/code`,
            reqDto,
            {
                headers: baseHeaders,
            }
        );

        return response.data;
    }

    async updatePgCode(
        reqDto: CommonRequestBodyDto<PgCodeUpdateReqDto>
    ): Promise<SuccessResponse<{ idPgCode: number }>> {
        const baseHeaders = this.makeBaseHeader();

        await axios.options(`${this.BASE_SERVICE_URL}/pg/code`, {
            headers: baseHeaders,
        });

        const response = await axios.put<SuccessResponse<{ idPgCode: number }>>(
            `${this.BASE_SERVICE_URL}/pg/code`,
            reqDto,
            {
                headers: baseHeaders,
            }
        );

        return response.data;
    }
}

export default RealPgCodeApi;
